(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('swifPanelService', swifPanelService);


    /**
    * @ngdoc service
    * @name swif.framework.swifPanelService
    * @requires swif.framework.msgService
    * @requires swif.framework.dataService
    * @description provide default to create panel directives
    **/
    function swifPanelService($q, msgService, dataService) {
        'ngInject';
        var data = dataService;
        var message = msgService;
        var service = {};
        service.data = data;

        service.create_directive = function (content_type, params, linked) {
            var directive = {
                restrict: 'AE',
                replace: true,
                transclude: true,
                require: 'ngModel',
                scope: {
                    update: '=?'
                },
                link: function (scope, element, attr, ngModel) {
                    scope.loading = {panel: {}, modelDefer: true};
                    if (scope.update === null) {
                        scope.update = true; //BBB
                    }
                    scope.first = true;
                    ngModel.$render = function () {
                        delete scope.item;
                        var vv = ngModel.$viewValue;
                        if (_.isUndefined(vv)) {
                            return;
                        }
                        if (_.isNumber(vv)) {
                            message.loading(scope.loading.panel);
                            scope.loading.modelDefer = data.get(content_type, vv, params)
                            .then(function (item) {
                                scope.item = item;
                                message.loading(scope.loading.panel, 'ok');
                            }, function () {
                                message.loading(scope.loading.panel, 'ko');
                            });
                        } else if (_.isObject(vv)) {
                            scope.item = ngModel.$viewValue;
                            if (scope.item.id) {
                                if (scope.update) {
                                    data.get(content_type, scope.item.id, params)
                                    .then(function (item) {
                                        data.updateObj(item, scope.item);
                                        // scope.loading.modelDefer.resolve();
                                        scope.loading.modelDefer = true;
                                    });
                                } else {
                                    // scope.loading.modelDefer.resolve();
                                    scope.loading.modelDefer = true;
                                }
                            } else {
                                // scope.loading.modelDefer.resolve();
                                scope.loading.modelDefer = true;
                            }
                        } else if (_.isBoolean(vv)) {
                            scope.loading.modelDefer = false;
                        } else {
                            message.addError('ERROR: wrong type on ngModel ?');
                            scope.loading.modelDefer = false;
                        }
                        // call it only the 1st time an item is filled
                        // but do not call it when no item has not been set yet
                        // otherwise, linked is never triggered when panel is initialize with no value (planning panel, etc.)
                        if (linked) {
                            $q.when(scope.loading.modelDefer).then(function () {
                                if (scope.first) {
                                    scope.first = false;
                                    linked(scope, element, attr, ngModel);
                                }
                            });
                        }
                    };
                }
            };
            return directive;
        };
        return service;
    }
})();
